module.exports = __webpack_public_path__ + "img/Surgeon@2x.41d48f5e.png";